import * as Transform from './transform_generated';
import * as WebGL from './webgl_generated';

exports = Object.assign({}, Transform.RockIt, WebGL.RockIt);



// WEBPACK FOOTER //
// ./src/common/component/index.ts